import React, { useEffect } from 'react';
import { Translation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import Logger from '../../../../../lib/Logger';

import { Typography } from 'antd';
import LearningAdminModulesGridList from '../containers/LearningAdminModulesGridListContainer';

const { Title } = Typography;

const LearningAdminModuleSeriesList = ({
  list,
  action,
  partnershipId,
  load,
  value,
  defaultLimit,
  defaultOrder,
  total,
  totalRecommended,
  totalMoreContent,
  view,
  activeKey,
  trackerActions,
  ...props
}) => {
  useEffect(() => {
    const filter = { [action.split('_not')[0]]: value };

    load(partnershipId, action, filter, 1, defaultLimit, defaultOrder);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partnershipId, action, load]);

  const totalTypes = [
    {
      key: 'recommended',
      label: 'learning_module_serie_recommended',
      value: totalRecommended,
    },
    {
      key: 'recommended_not',
      label: 'learning_module_serie_recommended_not',
      value: totalMoreContent,
    },
  ];

  return (
    <Translation>
      {(t) => (
        <>
          {list.length > 0 && (
            <>
              {totalTypes
                .filter((x) => x.key === action)
                .map(
                  ({ key, label, value }) =>
                    value > 0 && (
                      <Title
                        key={key}
                        level={3}
                        className='learning-title'
                        style={{ marginBottom: '0', marginTop: '20px' }}
                      >
                        {t(label)}
                      </Title>
                    )
                )}

              {list.map((x, index) => (
                <>
                  <LearningAdminModulesGridList
                    moduleSerieId={x.id}
                    moduleSerieTitle={x.title}
                    view={view}
                    activeKey={activeKey}
                    trackerActions={trackerActions}
                  />
                </>
              ))}
            </>
          )}
        </>
      )}
    </Translation>
  );
};

export default withRouter(LearningAdminModuleSeriesList);

Logger.log('silly', `LearningAdminModuleSeriesList loaded.`);
